import { convertUTCtoUserLocalTimeZone } from 'src/app/utils/utils';
import * as moment from 'moment-timezone';

const getDateBasedOnTab = (
  uploadedDate = '',
  printedDate = '',
  manifestedDate = '',
  currentTab = 0
) => {
  switch (currentTab) {
    case 0:
      return uploadedDate;
    case 1:
      return printedDate;
    case 2:
      return manifestedDate;
    default:
      return uploadedDate;
  }
};

const checkObjectValue = item => {
  return item ? item : '';
};

const checkObjectExist = (item, key) => {
  return item.hasOwnProperty(key);
};

const convertBabyShipment = (response, activeTab) => {
  return response.map(item => ({
    ...item,
    transitDate: item?.transitDate || null,
    customerReference: item?.shipperReference,
    shipmentDate: checkObjectValue(
      convertUTCtoUserLocalTimeZone(
        getDateBasedOnTab(
          item?.upload_datetime,
          item?.printed_date ? item?.printed_date : item.piecePrintedDate,
          item?.manifested_date,
          activeTab
        ),
        item?.timezone,
        moment.tz.guess()
      )
    ),
    shipperName: checkObjectExist(item, 'shipperDetails')
      ? item?.shipperDetails?.address_details?.shipperCompanyName
        ? item?.shipperDetails?.address_details?.shipperCompanyName
        : item?.shipperDetails?.shipperCompanyName
      : '',
    OriginCountry: checkObjectExist(item, 'shipperDetails')
      ? item?.shipperDetails?.address_details?.shipperCountryCode
        ? item?.shipperDetails?.address_details?.shipperCountryCode
        : item?.shipperDetails?.shipperCountryCode
      : '',
    receiverName: checkObjectExist(item, 'receiverDetails')
      ? item?.receiverDetails?.address_details?.receiverCompanyName
        ? item?.receiverDetails?.address_details?.receiverCompanyName
        : item?.receiverDetails?.receiverCompanyName
      : '',
    DestinationCountry: checkObjectExist(item, 'receiverDetails')
      ? item?.receiverDetails?.address_details?.receiverCountryCode
        ? item?.receiverDetails?.address_details?.receiverCountryCode
        : item?.receiverDetails?.receiverCountryCode
      : '',
    shipmentStatus: item?.status,
    pieceStatus: item?.piece_status ? item.piece_status : '',
    totalWeight: item?.totalWeight ? item.totalWeight : '-',
    noOfPieces: item?.noOfPieces ? item.noOfPieces : 0,
    shipment_warning: item?.shipment_warning,
  }));
};

export { convertBabyShipment };
